import axios from '@/libs/api.request'
import { fmtSearchParams } from '@/libs/util'

// 预警记录列表
export const list = (params) => {
  let postParams = fmtSearchParams(params)
  return axios.request({
    method: 'post',
    data: postParams,
    url: '/modules/warning/warningLog/list'
  })
}

// 预警记录列表
export const getTodoLogsCnt = () => {
  return axios.request({
    method: 'post',
    url: '/modules/warning/warningLog/getTodoLogsCnt'
  })
}

export const recList = (params) => {
  let postParams = fmtSearchParams(params)
  return axios.request({
    method: 'post',
    data: postParams,
    url: '/modules/warning/warningLogRecord/list'
  })
}

export const save = (params) => {
  let postParams = fmtSearchParams(params)
  return axios.request({
    method: 'post',
    data: postParams,
    url: '/modules/warning/warningLog/save'
  })
}



// WEBPACK FOOTER //
// ./src/api/iot/modules/warning-api.js